module.exports = __webpack_public_path__ + "static/why-2-821e35184176468a97e68030bf233c90.png";